import { isDevLikeHost, isTestLikeHost } from './config.js'

const BUILD_ENV = import.meta.env || {}

function isDevSite() {
  try {
    return isDevLikeHost(window.location.hostname)
  } catch {
    return false
  }
}

function isTestSite() {
  try {
    return isTestLikeHost(window.location.hostname)
  } catch {
    return false
  }
}

function environmentPortalOrigin(raw) {
  const fallback = isTestSite() ? 'https://iam-test.chamii.com' : isDevSite() ? 'https://iam-dev.chamii.com' : 'https://iam.chamii.com'
  const value = String(raw || '').trim()
  if (!value) return fallback
  try {
    const url = new URL(value)
    if (isTestSite() && ['iam.chamii.com', 'iam-api.chamii.com', 'iam-backend.chamii.com', 'iam-dev.chamii.com', 'iam-backend-dev.chamii.com'].includes(url.hostname)) {
      return 'https://iam-test.chamii.com'
    }
    if (isDevSite() && ['iam.chamii.com', 'iam-api.chamii.com', 'iam-backend.chamii.com'].includes(url.hostname)) {
      return 'https://iam-dev.chamii.com'
    }
    return url.origin
  } catch {
    return fallback
  }
}

export function getIamPortalOrigin() {
  const explicit = String(BUILD_ENV.VITE_IAM_PORTAL_ORIGIN || '').trim()
  if (explicit) return environmentPortalOrigin(explicit)
  const legacyBase = String(BUILD_ENV.VITE_IAM_LOGIN_BASE_URL || '').trim()
  return environmentPortalOrigin(legacyBase)
}

export function getIamLoginBaseUrl() {
  return `${getIamPortalOrigin()}/auth/login`
}

export function getIamAppKey() {
  try {
    if (String(window.location.hostname || '').toLowerCase() === 'vibokey.chamii.com') return 'vibokey'
  } catch {
    // Fall through to build-time configuration outside a browser.
  }
  const raw = String(BUILD_ENV.VITE_IAM_APP_KEY || BUILD_ENV.VITE_OIDC_CLIENT_ID || 'chamii').trim()
  if (['chamii', 'chamii-dev', 'chamii-main', 'chamii-main-dev'].includes(raw)) return 'chamii'
  return raw || 'chamii'
}

export function buildIamPortalUrl(nextPath) {
  const portal = new URL(`${getIamLoginBaseUrl()}/${encodeURIComponent(getIamAppKey())}`)
  const back = new URL('/login', window.location.origin)
  back.searchParams.set('next', nextPath || '/')
  back.searchParams.set('auto', '1')
  portal.searchParams.set('next', back.toString())
  return portal.toString()
}
